// noinspection DuplicatedCode

import Swal from 'sweetalert2';
import manager from 'app/module46/component-manager.js';

manager.register('table-viewer', (component, elements, attributes, properties) => {
	let canvas = null;
	let ctx;
	let img = document.createElement("img");
	let prevBtn;
	let nextBtn;
	let imageWidth;
	let imageHeight;
	let centerShiftX;
	let centerShiftY;

	let position = 0;
	let circles;

	let width;
	let height;

	let {
		tables,
		tableCount,
		title,
	} = properties;

	tableCount = parseInt(tableCount);

	const { template } = elements;
	const html = template.innerHTML;

	component.addEventListener('click', () => {
		showTableModal();
	});

	function next() {
		position++;
		if (position === tableCount) {
			position = 0;
		}

		circles = tables[position].circles;

		if (tables[position].imageEl) {
			img = tables[position].imageEl;

			requestAnimationFrame(drawContents);
		} else {
			tables[position].imageEl = document.createElement("img");

			tables[position].imageEl.onload = () => {
				img = tables[position].imageEl;

				requestAnimationFrame(drawContents);
			}

			tables[position].imageEl.src = tables[position].image;
		}
	}

	function prev() {
		position--;
		if (position < 0) {
			position = tableCount - 1;
		}

		circles = tables[position].circles;

		if (tables[position].imageEl) {
			img = tables[position].imageEl;

			requestAnimationFrame(drawContents);

		} else {
			tables[position].imageEl = document.createElement("img");

			tables[position].imageEl.onload = () => {
				img = tables[position].imageEl;

				requestAnimationFrame(drawContents);
			}

			tables[position].imageEl.src = tables[position].image;
		}
	}

	function drawContents() {
		fit(canvas.width, canvas.height, img.width, img.height);

		ctx.clearRect(0, 0, width, height);
		ctx.fillRect(0, 0, width, height);

		ctx.drawImage(img, centerShiftX, centerShiftY, imageWidth, imageHeight);

		for (const circleKey in circles) {
			const circle = circles[circleKey];

			ctx.beginPath();
			ctx.lineWidth = circle.thickness / 2;
			ctx.strokeStyle = "#004FFF";
			ctx.arc(circle.pos_x / 2, circle.pos_y / 2, circle.radius / 2, 0, 2 * Math.PI);
			ctx.stroke();
		}
	}

	function fit(parentWidth, parentHeight, childWidth, childHeight, offsetX = 0.5, offsetY = 0.5) {
		const childRatio = childWidth / childHeight;
		const parentRatio = parentWidth / parentHeight;
		imageWidth = childWidth;
		imageHeight = childHeight;

		if (childRatio > parentRatio) {
			imageWidth = parentWidth;
			imageHeight = imageWidth / childRatio
		} else {
			imageHeight = parentHeight;
			imageWidth = imageHeight * childRatio;
		}

		centerShiftX = (parentWidth - imageWidth) * offsetX;
		centerShiftY = (parentHeight - imageHeight) * offsetY;
	}

	function showTableModal() {
		Swal.fire({
			title,
			html,
			showConfirmButton: false,
			showCloseButton:   true,
			customClass:       {
				popup:     "table-swal-half",
				container: "table-swal",
			},
			willOpen:          (popup) => {
				prevBtn = document.getElementById('prev');
				nextBtn = document.getElementById('next');
				canvas = popup.getElementsByClassName('table__canvas')[0];
				ctx = canvas.getContext('2d');

				if (tableCount === 1) {
					prevBtn.style.display = 'none';
					nextBtn.style.display = 'none';

				} else {
					prevBtn.addEventListener('click', prev);
					nextBtn.addEventListener('click', next);
				}

				width = canvas.width;
				height = canvas.height;

				circles = tables[position].circles;

				if (tables[position].imageEl) {
					img = tables[position].imageEl;

					requestAnimationFrame(drawContents);

				} else {
					tables[position].imageEl = document.createElement("img");

					tables[position].imageEl.onload = () => {
						img = tables[position].imageEl;

						requestAnimationFrame(drawContents);
					}

					tables[position].imageEl.src = tables[position].image;
				}
			}
		});
	}
});
